import permissions from '../../permissions'

const SMTP_CREDENTIAL_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.SMTP_CREDENTIAL.MANAGE,
  },
]

export default SMTP_CREDENTIAL_LIST
